export default function mapperToBenefactorRequest(formData) {
  return {
    "Tipo de Benemérito": formData.benefactorType,
    "Declaração de aceite ": formData.accepted,
    "Termo de aceite": formData.accepted == "Sim" ? "Eu declaro que estou ciente das regras e orientações referente a solicitação de Benemérito" :
                        "",
  };
}
